
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const USER_EXTEND_EXPIRATION = 'USER_EXTEND_EXPIRATION'
export const ADD_PROD = 'ADD_PROD'
export const LIST_PROD = 'LIST_PROD'
export const REMOVE_PROD = 'REMOVE_PROD'
export const LIMPAR_CARRINHO = 'LIMPAR_CARRINHO'
export const SELECIONA_FRETE = 'SELECIONA_FRETE'
export const ALTERAR_PROD = 'ALTERAR_PROD'
export const EMPRESA_LOGGED_IN = 'EMPRESA_LOGGED_IN'
export const EMPRESA_LOGGED_OUT = 'EMPRESA_LOGGED_OUT'
export const PESQUISAR = 'PESQUISAR'
export const LIMPA_PESQUISA = 'LIMPA_PESQUISA'
export const REMOVE_FRETE = 'REMOVE_FRETE'
export const SELECIONA_GRUPO_CLASSIFICADO = 'SELECIONA_GRUPO_CLASSIFICADO'
export const ADD_SERVER = 'ADD_SERVER'
export const LIMPA_SERVER = 'LIMPA_SERVER'